module.exports = __webpack_public_path__ + "img/6_138.deb7f244.png";